import { stdObject } from "../../../data/types/stdObject";

export const getVersionName = ({ name, cVersion, nVersion, t }: stdObject) => {
  let vName = "";
  switch (cVersion) {
    case "basic":
      vName = "p.basicVersion";
      break;
    case "medium":
      vName = "p.mediumVersion";
      break;
    case "full":
      vName = "p.fullVersion";
      break;
  }
  return `${name} ${nVersion} (${t(vName)})`;
};
